import { z as validator } from 'zod';

export default validator;
